export default {
  admins: "Admin",
  users: "External User",
  arm_users: "Internal User",
};
